import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading text-primary-400">51cg</span>
              <span className="text-sm text-foreground-400">吃瓜网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-sm">
              51cg吃瓜网是国内领先的娱乐资讯聚合平台，提供最新娱乐八卦、明星动态、影视综艺和社会热点资讯，做最懂"吃瓜群众"的娱乐资讯平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              <a href="#footer-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              <a href="#footer-links" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  联系方式
                </Link>
              </li>
              <li>
                <span className="text-sm text-foreground-500">客服热线：400-888-5151</span>
              </li>
              <li>
                <span className="text-sm text-foreground-500">邮箱：contact@51cg.fun</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 51cg吃瓜网 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-5">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="https://douyin.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}